import { TagProps, Tag as _Tag } from 'antd';

import { getClassName } from '../_utils';

type Props = {
  label: string | number;
} & Pick<TagProps, 'className' | 'color' | 'style'>;

/**
 * returns JSX for tag
 */
export function Tag({ label, className, color, style }: Props) {
  return (
    <_Tag
      className={getClassName('tag', className)}
      color={color}
      style={style}
    >
      {label}
    </_Tag>
  );
}
